import {isMobile} from 'react-device-detect';
import './Brand.css'
import backgroundM from './bg_1.jpg'
import backgroundD from './bg_1.jpg'
function device() {
  if (isMobile) {
    return backgroundM
  } else {
    return backgroundD
  }
}

function Brand() {
    return (
      <div id="brand">
        <div className='left'>
          <div>
              <p className='georgia'>Бренд современных безопасных дезодорантов</p>
              <p>
              Бережно борется с неприятным запахом без разражения, дискомфорта и вредя для здоровья. 
              <br></br>Инновационные формулы сочетают AHA-кислоты и увлажняющие компоненты.
              <br></br>Устраняет причину запаха, не нарушая естественных процессов потоотделения. 
              <br></br>
              <br></br>
              Не тестируем средства на животных и не используем ингредиенты животного происхождения.

              </p>
              {/* <button>
                Подробнее
              </button> */}
            </div>  
        </div>
        {/* <div className='right' style={{ backgroundImage: `url(${device()})` }}>
        </div> */}
      </div>
    );
  }
  
  export default Brand;